// Muslink Logo SVG Component - Fullcolor version
export default function MuslinkLogo({ className = "", height = 32, theme = "dark" }) {
  // Use dark blue for light theme, white for dark theme
  const fillColor = theme === "light" ? "#121B44" : "#ffffff";
  
  return (
    <svg 
      viewBox="0 0 224.3 49.7" 
      height={height}
      className={className}
      style={{ width: 'auto' }}
    >
      <g fill={fillColor}>
        <path d="M37.8,0h9.9v48.7h-9.5V17.1L24.4,39.7h-1.1L9.6,17.2v31.5H0V0h9.9l14,23L37.8,0z"/>
        <path d="M77.5,32.7V13.9h9v34.8h-9v-3.9c-2.1,3.2-5.6,4.9-10.4,4.9c-3.8,0-7-1.3-9.5-3.8c-2.5-2.6-3.7-6.1-3.7-10.6 V13.9h9v20.2c0,2.3,0.6,4,1.8,5.3c1.2,1.3,2.9,1.9,5,1.9c2.4,0,4.2-0.7,5.6-2.2C76.8,37.7,77.5,35.5,77.5,32.7z"/>
        <path d="M100.9,23.8c0,1.5,2.1,2.8,6.3,3.8c1.5,0.3,2.8,0.7,4,1.1c1.2,0.4,2.4,1.1,3.7,1.9c1.2,0.8,2.2,1.9,2.9,3.2 c0.7,1.3,1,2.9,1,4.7c0,3.6-1.3,6.3-4,8.3c-2.7,1.9-6,2.9-9.9,2.9c-7.1,0-12-2.8-14.6-8.3l7.8-4.4c1.1,3,3.3,4.5,6.8,4.5 c3.2,0,4.8-1,4.8-3c0-1.5-2.1-2.8-6.3-3.8c-1.6-0.4-2.9-0.8-4-1.3c-1.1-0.4-2.3-1-3.6-1.8c-1.3-0.8-2.3-1.9-3-3.1 c-0.7-1.3-1-2.8-1-4.5c0-3.4,1.3-6.1,3.8-8.1c2.5-2,5.7-3,9.5-3c2.8,0,5.4,0.6,7.7,1.9c2.3,1.3,4.2,3.1,5.5,5.5l-7.7,4.2 c-1.1-2.4-3-3.5-5.6-3.5c-1.2,0-2.1,0.3-2.9,0.8C101.3,22.3,100.9,23,100.9,23.8z"/>
        <path d="M131.9,48.7h-9V0h9V48.7z"/>
        <path d="M147.3,48.7h-9V13.9h9V48.7z"/>
        <path d="M173.1,12.9c3.8,0,7,1.3,9.4,3.8c2.5,2.6,3.8,6.1,3.8,10.6v21.4h-9V28.5c0-2.3-0.6-4-1.8-5.3 c-1.2-1.3-2.9-1.9-5-1.9c-2.4,0-4.2,0.7-5.6,2.2c-1.4,1.5-2.1,3.6-2.1,6.4v18.8h-9V13.9h9v3.9C164.9,14.6,168.4,12.9,173.1,12.9z"/>
        <path d="M209.9,31.1l14.4,17.6h-10.4l-12.7-15.8v15.8h-9V0h9v29.2l12-15.3h10.7L209.9,31.1z"/>
      </g>
      <defs>
        <linearGradient id="muslink-gradient" x1="138.4" y1="4.5" x2="186.3" y2="4.5" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ED1F83"/>
          <stop offset="1" stopColor="#ED1F83" stopOpacity="0"/>
        </linearGradient>
      </defs>
      <rect x="138.4" y="0" width="47.9" height="9" fill="url(#muslink-gradient)"/>
    </svg>
  );
}
